angular.module('am4')
.filter('seriesName', function($translate) {
    return function(input) {
        if (input === 'UNKNOWN') {
            return $translate.instant(input);
        } else if (angular.isString(input)) {
            // On matrixfitness.com, series all start with capital letters
            return input.charAt(0).toUpperCase() + input.slice(1);
        }
        return input;
    };
});



// WEBPACK FOOTER //
// ./src/app/filters/seriesName.js